import util from 'Utils/commonUtil';
import {get, post, callApi} from 'Utils/apiUtil';
import {
    myOrderListUrl,
    myOrderDetailUrl,
    cancelOrderUrl,
    repeatOrderUrl,
    getOnlineCustomerAccountUrl,
    getShipmentsUrl,
    receiveShipmentUrl,
    getSearchSCList,
    saveShippingPlanUrl,
    getShippingPlanListUrl,
    completeShippingPlanUrl,
    updateOrderProofsUrl,
} from 'Utils/urlUtil';
import {setShipToData, setSCData} from 'Actions/localData';
import {T} from 'Actions/translate';

export const MYORDERLIST = 'MYORDERLIST';
export const MYORDERSEARCHLIST = 'MYORDERSEARCHLIST';
export const MYORDERITEMDETAIL = 'MYORDERITEMDETAIL';
export const UPDATE_MYORDERITEMDETAIL = 'UPDATE_MYORDERITEMDETAIL';
export const REPEAT_ORDER = 'REPEAT_ORDER';

// Update Order Proofs
export const UPDATE_ORDER_PROOFS = 'UPDATE_ORDER_PROOFS';
export const UPDATE_MY_ORDER_PROOFS_LOCAL = 'UPDATE_MY_ORDER_PROOFS_LOCAL';

export const GET_SEARCH_SC_LIST = 'GET_SEARCH_SC_LIST';
export const MY_ORDER_SEARCH_FIELD = 'MY_ORDER_SEARCH_FIELD';
export const UPDATEMYORDERSEARCHLIST = 'UPDATEMYORDERSEARCHLIST';
export const ORDER_SEARCH_IS_LAST_PAGE = 'ORDER_SEARCH_IS_LAST_PAGE';
export const GET_CUSTOMER_ACCOUNT = 'GET_CUSTOMER_ACCOUNT';
export const UPDATE_MYORDERLIST = 'UPDATE_MYORDERLIST';
export const SET_SALES_ONHOLD_STATUS = 'SET_SALES_ONHOLD_STATUS';

export const UPDATE_SEARCH_TYPE_OBJ = 'UPDATE_SEARCH_TYPE_OBJ';
export const UPDATE_SALES_ORDER_PAGE_NUM = 'UPDATE_SALES_ORDER_PAGE_NUM';
export const SET_CURRENT_ORDER_ID = 'SET_CURRENT_ORDER_ID';
export const UPDATE_UNRECEIVED_ORDER_LIST = 'UPDATE_UNRECEIVED_ORDER_LIST';
export const SET_FROM_MY_ORDER_DETAILS = 'SET_FROM_MY_ORDER_DETAILS';

export const GET_SHIPPING_PLAN_LIST = 'GET_SHIPPING_PLAN_LIST';
export const UPDATE_SHIPPING_PLAN_DATA = 'UPDATE_SHIPPING_PLAN_DATA';
export const COMPLETED_SHIPPING_PLAN = 'COMPLETED_SHIPPING_PLAN';

export const getMyOrderList = (data) => (dispatch) => {
    let tab = '';
    switch (data.tabFlag) {
        case 1:
            tab = 'noReceive';
            break;
        case 2:
            tab = 'received';
            break;
        case 3:
            tab = 'canceled';
            break;
        default:
    }

    if (data.pageNum === 1)
        dispatch({type: MYORDERLIST, payload: {pageNum: 1, data: [], tab}});
    return dispatch(post(myOrderListUrl, data)).then((res) => {
        res.tab = tab;
        if (res.data.length < res.pageSize) {
            dispatch({
                type: ORDER_SEARCH_IS_LAST_PAGE,
                payload: {orderSearchIsLastPage: true},
            });
        }
        dispatch({type: MYORDERLIST, payload: res});
        return res;
    });
};

// export const getMyOrderSearchList = data => dispatch => dispatch(post(myOrderListUrl, data))
//     .then(res => {
//         dispatch({ type: MYORDERSEARCHLIST, payload: res });
//         return res;
//     });

// Update F1 Order Search Fields
export const updateMyOrderSearchFields = (params) => ({
    type: MY_ORDER_SEARCH_FIELD,
    payload: params,
});

export const updateMyOrderSearchList = (params) => ({
    type: UPDATEMYORDERSEARCHLIST,
    payload: params,
});

export const updateMyOrderList = (params) => ({
    type: UPDATE_MYORDERLIST,
    payload: params,
});

export const updateSearchTypeObj = (params) => ({
    type: UPDATE_SEARCH_TYPE_OBJ,
    payload: params,
});

export const getMyOrderSearchList = (params) => {
    return async (dispatch, getState) => {
        // const request = null

        // const options = {
        //     data: params
        // }

        // const success = (response) => {
        //     console.log(response);
        //     if (response.data.length > 0 && response.data.length < response.pageSize) {
        //         dispatch({ type: ORDER_SEARCH_IS_LAST_PAGE, payload: { orderSearchIsLastPage: true } });
        //     }
        //     return { type: MYORDERSEARCHLIST, payload: { ...response } }
        // }
        // const failure = null

        // return callApi(myOrderListUrl, options, request, success, failure)
        return dispatch(post(myOrderListUrl, params)).then(async (res) => {
            if (res.data.length < res.pageSize) {
                dispatch({
                    type: ORDER_SEARCH_IS_LAST_PAGE,
                    payload: {orderSearchIsLastPage: true},
                });
            }
            dispatch({type: MYORDERSEARCHLIST, payload: {...res}});
            return res;
        });
    };
};

export const updateOrderSearchIsLastPage =
    (orderSearchIsLastPage) => (dispatch) =>
        dispatch({
            type: ORDER_SEARCH_IS_LAST_PAGE,
            payload: {orderSearchIsLastPage},
        });

// export const addCart = (params) => {

//     const request = null

//     const options = {
//         data: params
//     }

//     const success = (response) => ({ type: ADD_CART, payload: { ...response } })
//     const failure = null

//     return callApi(addCartUrl, options, request, success, failure)
// };

export const getMyOrderItemDetail =
    (params, includeShipments = true) =>
    (dispatch) => {
        dispatch({type: MYORDERITEMDETAIL, payload: {}});
        return dispatch(
            get(myOrderDetailUrl, {
                ...params,
                includeShipments,
            }),
        ).then((res) => {
            dispatch({type: MYORDERITEMDETAIL, payload: res.data});
            return res;
        });
    };

export const cancelOrder = (data, callback) => (dispatch) =>
    dispatch(post(cancelOrderUrl, data)).then((res) => {
        if (util.isFunction(callback)) callback(res);
    });

export const repeatOrder = (params, func) => {
    const request = null;

    delete params.shipToNum;
    const options = {
        data: params,
    };

    const success = [
        (response) => ({type: REPEAT_ORDER, payload: response}),
        (response) => {
            if (
                response &&
                response.data &&
                response.data.shipToSupplyCenter &&
                response.data.shipToSupplyCenter !== null
            ) {
                setSCData({
                    id: response.data.shipToSupplyCenter.supplyCenterId,
                    name: response.data.shipToSupplyCenter.supplyCenterName,
                    type: 1,
                });
            } else {
                setSCData({
                    id: -1,
                    name: '',
                    type: 1,
                });
            }
        },
        (response) => setShipToData(response.data.shipToSupplyCenter),
    ];

    const failure = null;

    return callApi(repeatOrderUrl, options, request, success, failure, func);
};

export const getShipments = (params) => get(getShipmentsUrl, params);
export const receiveShipment = (data) => post(receiveShipmentUrl, data);

export function getSearchSCLists() {
    return (dispatch) =>
        dispatch(get(getSearchSCList)).then((res) => {
            const data = res.data.map((d) => ({
                label: d.name,
                value: d.name,
                value2: d.id,
            }));
            const noSCName = {
                label: T('no_supply_center'),
                value: T('no_supply_center'),
                value2: -1,
            };
            data.push(noSCName);
            dispatch({type: GET_SEARCH_SC_LIST, payload: data});
        });
}

export const getCustomerAccount = (data) => (dispatch) =>
    dispatch(post(getOnlineCustomerAccountUrl, data)).then((res) => {
        dispatch({type: GET_CUSTOMER_ACCOUNT, payload: res});
        return res;
    });

// Sales order on hold
export const setSalesOrderOnholdStatus = (params) => ({
    type: SET_SALES_ONHOLD_STATUS,
    payload: params,
});

// Update my Order 未收货列表page num
export const updateSalesOrderListPageNum = (params) => ({
    type: UPDATE_SALES_ORDER_PAGE_NUM,
    payload: params,
});

// set my order id
export const setCurrentOrderId = (params) => ({
    type: SET_CURRENT_ORDER_ID,
    payload: params,
});

// Update my Order Search Fields
export const updateUnreceivedOrderList = (params) => ({
    type: UPDATE_UNRECEIVED_ORDER_LIST,
    payload: params,
});

//是否从my order detail来
export const setFromMyOrderDetails = (params) => ({
    type: SET_FROM_MY_ORDER_DETAILS,
    payload: params,
});

export const saveShippingPlan = (params) => post(saveShippingPlanUrl, params);

export const getShippingPlanList = (data) => (dispatch) =>
    dispatch(post(getShippingPlanListUrl, data)).then((res) => {
        dispatch({type: GET_SHIPPING_PLAN_LIST, payload: res});
        return res;
    });

export const updateOrderProofs = (data) => (dispatch) =>
    dispatch(post(updateOrderProofsUrl, data)).then((res) => {
        dispatch({type: UPDATE_ORDER_PROOFS, payload: res});
        return res;
    });

// Update MY ORDER DETAIL
export const updateMyOrderDetails = (params) => ({
    type: UPDATE_MYORDERITEMDETAIL,
    payload: params,
});

// Update only orderProofs inside myOrderItemDetail
export const updateMyOrderProofsLocal = (orderProofs) => ({
    type: UPDATE_MY_ORDER_PROOFS_LOCAL,
    payload: orderProofs,
});

export const completeShippingPlan = (params) => (dispatch) =>
    dispatch(post(completeShippingPlanUrl + '/' + params.planId)).then(
        (res) => {
            dispatch({type: COMPLETED_SHIPPING_PLAN, payload: res});
            return res;
        },
    );
